import React , { useState }from 'react'


import { useNavigate  } from "react-router-dom";


import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';



function Login() {

    const [inputValue,setInputValue] = useState( null )
    const [logError,setLogError] = useState( false )
    const [loggin,setLoggin] = useState( false )
    const [textError,setTextError] = useState( "")

    function onLogin()
    {
        setTextError( "Error en el Login")
        setLogError( true ) ;

    }

    function setTheInputValue( value )
    {
        console.log( "setTheImputValue" ) ;

        setInputValue( value )
    }



  return (
    

        <div className='card' style={{backgroundColor:'#f9fafb'}}>

        <div className="flex flex-columna md:flex-row">
            <div className="w-full md:w-12 flex flex-column align-items-center justify-content-center gap-3 py-5">
                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="w-5rem">Usuario</label>
                    <InputText id="username" type="text" onFocus={() => setLogError(false )}
                    className="md:w-12" style={{border:'1px solid', borderColor : 'purple'}}/>
                </div>

                {/* w-12rem  md:w-12*/}
                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="md:w-4">Password</label>
                    <Password className=""  value={inputValue} onChange={(e) => setTheInputValue(e.target.value)} style={{border:'1px solid', borderColor : 'purple'}}
                        id='password' onFocus={() => setLogError(false )}
                        promptLabel="Teclee un Password" weakLabel="Muy simple" mediumLabel="Complejidad Mediana" strongLabel="Password Complejo" toggleMask />
                </div>

                <Button label="Login" icon="pi pi-user" onClick={onLogin}
                    className="w-10rem mx-auto"></Button>

                    {
                        logError && (
                            <div  className="w-12rem m-4">

                                <Message onClick={() => setLogError(false )} severity="error" text={textError}/>


                            </div>
                        )
                    }

                    {
                        loggin && (
                            <ProgressSpinner style={{width: '50px', height: '50px'}}/>
                        )
                    }

            </div>

        </div>

        </div>

                )

}

export default Login
